export const PARKING_TIME_STEP_MINUTES = 15

export const MINIMUM_PARKING_DURATION_MINUTES = 60

export function normalizeTime(value) {
    if (!value) {
        return ''
    }

    if (typeof value === 'object') {
        return normalizeTime(value.default || value.military_time || value.standard_time)
    }

    if (typeof value !== 'string') {
        return ''
    }

    let value24 = value.trim().match(/^([01]?\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?$/)

    if (value24) {
        return `${value24[1].padStart(2, '0')}:${value24[2]}:${value24[3] || '00'}`
    }

    let value12 = value.trim().match(/^(\d{1,2}):([0-5]\d)\s*(AM|PM)$/i)

    if (!value12) {
        return ''
    }

    let hours = parseInt(value12[1], 10)
    let meridiem = value12[3].toUpperCase()

    if (hours < 1 || hours > 12) {
        return ''
    }

    if (meridiem === 'PM' && hours < 12) {
        hours += 12
    }

    if (meridiem === 'AM' && hours === 12) {
        hours = 0
    }

    return `${hours.toString().padStart(2, '0')}:${value12[2]}:00`
}

export function isTimeBefore(time, otherTime) {
    let normalized = normalizeTime(time)
    let otherNormalized = normalizeTime(otherTime)

    return Boolean(normalized && otherNormalized && normalized < otherNormalized)
}

export function isParkingDateRangeValid(checkinDate, checkoutDate) {
    let checkin = moment(checkinDate)
    let checkout = moment(checkoutDate)

    return checkin.isValid() && checkout.isValid() && !checkout.isBefore(checkin, 'day')
}

export function isParkingDurationValid(checkinDate, checkinTime, checkoutDate, checkoutTime) {
    let normalizedCheckinTime = normalizeTime(checkinTime)
    let normalizedCheckoutTime = normalizeTime(checkoutTime)

    if (!isParkingDateRangeValid(checkinDate, checkoutDate) || !normalizedCheckinTime || !normalizedCheckoutTime) {
        return false
    }

    let checkin = moment(checkinDate).startOf('day')
    let checkout = moment(checkoutDate).startOf('day')
    let checkinParts = normalizedCheckinTime.split(':').map(Number)
    let checkoutParts = normalizedCheckoutTime.split(':').map(Number)

    checkin.hour(checkinParts[0]).minute(checkinParts[1]).second(checkinParts[2])
    checkout.hour(checkoutParts[0]).minute(checkoutParts[1]).second(checkoutParts[2])

    return checkout.diff(checkin, 'minutes', true) >= MINIMUM_PARKING_DURATION_MINUTES
}

export function buildParkingTimes() {
    if (_.get(window, 'apr.times')) {
        return window.apr.times
    }

    let times = {'': 'Select a time'}
    let time = moment().startOf('day')

    for (let i = 0; i < (24 * 60) / PARKING_TIME_STEP_MINUTES; i++) {
        times[time.format('HH:mm:ss')] = time.format('h:mm A')
        time.add(PARKING_TIME_STEP_MINUTES, 'minutes')
    }

    return times
}
